import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Header from '../../layouts/Header';
import { Col, Row, Card, Badge, Button, Modal, Form } from 'react-bootstrap';
import Select from 'react-select';
import axiosInstance from '../../api/axios';import { toast } from 'react-toastify';

const PromoteProducts = () => {
    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [addAccess, setAddAccess] = useState([]);
    const [promotedProducts, setPromotedProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [defaultProductIds, setDefaultProductIds] = useState([]);
    const [inputOutlet, setInputOutlet] = useState('');
    const [outletProductIds, setOutletProductIds] = useState([]);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [isAddBtnLoading, setIsAddBtnLoading] = useState(false);
    const [promotionType, setPromotionType] = useState('default');
    const [selectedOutlet, setSelectedOutlet] = useState(null);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [loadingOutlets, setLoadingOutlets] = useState(false);
    const [loadingProducts, setLoadingProducts] = useState(false);
    const [selectedOutletId, setSelectedOutletId] = useState('');
    const [activeOutlets, setActiveOutlets] = useState([]);
    const [outlets, setOutlets] = useState([]);
    const [productsList, setProductsList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [listId, setListId] = useState("");
    const [currentPromotionId, setCurrentPromotionId] = useState(''); // Store current promotion ID
    
    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("PopupAdvertisement:")
            );
            setAddAccess(filteredAccess);
        }
    }, [access]);
    
    const accessToken = localStorage.getItem('authToken');

    const getPromotedProducts = async(outlet, groupId) => {
        try {
            setLoading(true);
            const headers = {
                Authorization:  `Bearer ${accessToken}`
            }
            
            let apiUrl;

            if (outlet) {
                apiUrl = `promoting-products?outletId=${outlet}&promotingId=${groupId}`
            } else {
                apiUrl = `promoting-products/getDefaultProducts?promotingId=${groupId}`
            }

            const response = await axiosInstance.get(apiUrl, { headers });
            console.log("Response :", response);
            
            if (response?.data?.status && response?.data?.data) {
                // Store the promotion ID and products
                setCurrentPromotionId(response?.data?.data?._id);
                setPromotedProducts(response?.data?.data?.products || []);
                
                // Store current product IDs based on outlet selection
                if (outlet) {
                    setOutletProductIds(response?.data?.data?.products?.map(product => product._id) || []);
                } else {
                    setDefaultProductIds(response?.data?.data?.products?.map(product => product._id) || []);
                }
            }
            
        } catch (error) {
            console.log("Error in Getting Promoting Products :", error);                        
        } finally {
            setLoading(false);
        }
    };

    // Remove product function
    const handleRemoveProduct = async (productId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };

            // Get current product IDs and remove the selected one
            let updatedProductIds;
            if (selectedOutletId) {
                // For outlet-specific promotion
                updatedProductIds = outletProductIds?.filter(id => id !== productId);
                setOutletProductIds(updatedProductIds);
            } else {
                // For default promotion
                updatedProductIds = defaultProductIds?.filter(id => id !== productId);
                setDefaultProductIds(updatedProductIds);
            }

            const reqBody = {
                _id: currentPromotionId,
                defaultProductIds: selectedOutletId ? [] : updatedProductIds,
                // outletProductIds: selectedOutletId ? updatedProductIds : []
            };

            console.log("Removing product - Request Body:", reqBody);

            const response = await axiosInstance.put('promoting-products', reqBody, { headers });
            
            if (response?.data?.status === true) {
                toast.success("Product removed successfully", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                console.log("Response of Remove :", response?.data?.data?._id);
                let groupId = response?.data?.data?._id;
                // Refresh the promoted products list
                getPromotedProducts(selectedOutletId, groupId);
            }
            
        } catch (error) {
            console.log("Error removing product:", error);
            let errorMessage;
            
            if (error?.response) {
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.message || error?.response?.data?.error;
                } else if (error.response?.status === 400) {
                    errorMessage = error?.response?.data?.message;
                } else if (error.response?.status === 402) {
                    errorMessage = error?.response?.data?.message;
                } else if (error.response?.status === 404) {
                    errorMessage = error?.response?.data?.message;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }
            }

            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        }
    };

    const getOutlets = async () => {
        try {
            setLoadingOutlets(true);
            const headers = { 
                Authorization: `Bearer ${accessToken}` 
            };
            const response = await axiosInstance.get("outlet", { headers });
            if (response?.data?.status === true) {
                const activeOutlets = response?.data?.data?.outlets.filter(outlet => outlet?.status === "ACTIVE");
                setActiveOutlets(activeOutlets);
                const formattedOutlets = activeOutlets.map(outlet => ({
                    value: outlet._id,
                    label: outlet.name
                }));
                setOutlets(formattedOutlets);
            }
        } catch (error) {
            console.error("Error fetching outlets:", error);
            toast.error("Failed to fetch outlets", {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        } finally {
            setLoadingOutlets(false);
        }
    };

    const getCategoryList = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("masters/category/get", { headers });

            if (response?.data?.status === true) {
            setCategoryList(response?.data?.data?.categories || []);
            }
        } catch (error) {
            // handleApiError(error);
        }
    };
    
    const getProductsList = async () => {
        try {
            setLoadingProducts(true);
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("product", { headers });
            if (response?.data?.status === true) {
                const products = response?.data?.data?.products?.filter((fil) => fil?.isFreebieProduct === false || []);
                setProductsList(products);
                setFilteredProducts(products);
                
                const formattedProducts = products.map(product => ({
                    value: product._id,
                    label: product.name,
                    ...product
                }));
                setProductsList(formattedProducts);
                setFilteredProducts(formattedProducts);
            }
        } catch (error) {
        //   handleApiError(error);
        } finally {
            setLoadingProducts(false);
        }
    };

    const handleOpenAddModal = (id, data) => {
        console.log("Get Id :", id);
        console.log("Data of products :", data);

        // Extract product IDs
        const productIds = data.map((item) => item._id);

        // Save in state (for API body later)
        setDefaultProductIds(productIds);

        // Also prepare selected options for <Select>
        const selectedOpts = data.map((item) => ({
            value: item._id,
            label: item.name
        }));
        setSelectedProducts(selectedOpts);

        // setListId(id);
        setOpenAddModal(true);
    };

    const handleCloseAddModal = () => {
        setOpenAddModal(false);
        setSelectedOutlet(null);
        // setSelectedProducts([]);
        setPromotionType('default');
    }

    const handleOutletChange = (selectedOption) => {
        setSelectedOutlet(selectedOption);
        setInputOutlet(selectedOption?.value || '');
    };

    const handleProductChange = (selectedOptions) => {
        setSelectedProducts(selectedOptions);
        
        const productIds = selectedOptions.map(option => option.value);
        if (promotionType === 'default') {
            setDefaultProductIds(productIds);
        } else {
            setOutletProductIds(productIds);
        }
    };

    const handleSubmit = async(e) => {
        e.preventDefault();
        setIsAddBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            
            let reqBody = {};
            
            if (promotionType === 'default') {
                reqBody = {
                    defaultProductIds: defaultProductIds
                };
            } else {
                reqBody = {
                    outlet: inputOutlet,
                    outletProductIds: outletProductIds
                };
            }
            
            console.log("Sending Body :", reqBody);
            const response = await axiosInstance.post('promoting-products', reqBody, { headers });
            console.log("Response :", response);
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                handleCloseAddModal();
                getPromotedProducts(selectedOutletId);
            }
            
        } catch (error) {
            console.log("Error :", error);
            if (error?.response) {
                let errorMessage = '';
                if ( error.response?.status === 406 ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if ( error.response?.status === 412 ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }
        
                toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
                });
            }
        } finally {
            setIsAddBtnLoading(false);
        }
    };

    const handleEditSubmit = async(e) => {
        e.preventDefault();
        setIsAddBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            let reqBody = {};
            
            if (promotionType === 'default') {
                reqBody = {
                    _id: currentPromotionId,
                    defaultProductIds: defaultProductIds
                };
            } else {
                reqBody = {
                    outlet: inputOutlet,
                    outletProductIds: outletProductIds
                };
            }
            const response = await axiosInstance.put(`promoting-products`, reqBody, { headers });
            console.log("Response Of :", response);
            let groupId = response?.data?.data?._id;
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                handleCloseAddModal();
                getPromotedProducts(selectedOutletId, groupId);
            }
        } catch (error) {
            console.log("Error :", error);
            if (error?.response) {
                let errorMessage = '';
                if ( error.response?.status === 406 ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                } else if ( error.response?.status === 400 ) {
                    errorMessage = error?.response?.data?.message;
                } else if ( error.response?.status === 412 ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }
        
                toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
                });
            }
        } finally {
            setIsAddBtnLoading(false);
        }
    }

    const handlePromotionTypeChange = (type) => {
        setPromotionType(type);
        setSelectedOutlet(null);
        setSelectedProducts([]);
        setDefaultProductIds([]);
        setOutletProductIds([]);
    };
    
    useEffect(() => {
        getPromotedProducts();
        getOutlets();
        getProductsList();
        getCategoryList();
    }, []);

    const formatPrice = (price) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0
        }).format(price);
    };

    const calculateDiscount = (mrp, offerPrice) => {
        return Math.round(((mrp - offerPrice) / mrp) * 100);
    };

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div
                    className="container shadow-sm"
                    style={{ 
                        backgroundColor: "white", 
                        borderRadius: '12px', 
                        overflow: 'hidden' 
                    }}
                >
                    <Row className="pt-3 align-items-center">
                        <Col>
                            <h5 className="fw-semibold mb-0">PROMOTE PRODUCTS</h5>
                        </Col>
                        <Col xs="auto" className="text-end">
                            <Button
                                variant="primary"
                                className="fw-semibold"
                                disabled={promotedProducts === 0}
                                onClick={() => handleOpenAddModal(promotedProducts[0]?._id, promotedProducts)}
                            >
                                <i className="ri-add-line" style={{ marginRight: "5px" }}></i>
                                Promote More Products
                            </Button>
                        </Col>
                        <hr className='mt-2' />
                    </Row>

                    <Row className="g-3">
                        <Col md={3}>
                            <Form.Group controlId="outletSelect">
                                <Form.Label className="fw-semibold">
                                    Select Outlet <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select
                                    value={selectedOutletId}
                                    onChange={(e) => 
                                        {
                                            let outId = e.target.value
                                            setSelectedOutletId(outId);
                                            getPromotedProducts(outId);
                                        }
                                    }
                                    className="border-secondary"
                                >
                                    <option value="">Default Products</option>
                                    {activeOutlets?.map((outName, index) => (
                                        <option key={index} value={outName?._id}>
                                            {outName?.name} ({outName?.city})
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    {loading ? ( 
                        <div style={{ textAlign: 'center', padding: '2rem 0' }}>
                            <div 
                                className="spinner-border text-primary" 
                                role="status"
                                style={{ width: '3rem', height: '3rem' }}
                            >
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p style={{ marginTop: '1rem' }}>Loading promoted products...</p>
                        </div>
                    ) : promotedProducts?.length > 0 ? (
                        <Row className='mt-3' style={{ gap: '1rem 0', padding: '0.75rem 0' }}>
                            {promotedProducts?.map((product) => (
                                <Col md={6} lg={2} key={product?._id} className="mb-3">
                                    <Card 
                                        style={{ 
                                            height: '100%', 
                                            borderRadius: '10px', 
                                            overflow: 'hidden',
                                            background: '#ffffff',
                                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                                            border: '1px solid #f0f0f0',
                                            transition: 'box-shadow 0.2s ease'
                                        }}
                                        className="product-card"
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.06)';
                                        }}
                                    >
                                        {/* Image Section */}
                                        <div style={{ 
                                            position: 'relative', 
                                            height: '140px', 
                                            overflow: 'hidden',
                                            background: '#f8f9fa'
                                        }}>
                                            <Card.Img 
                                                variant="top" 
                                                src={product?.coverImageUrl} 
                                                alt={product?.name}
                                                style={{ 
                                                    height: '100%', 
                                                    objectFit: 'cover',
                                                    width: '100%'
                                                }}
                                            />
                                            
                                            {/* Top Badges */}
                                            <div style={{
                                                position: 'absolute',
                                                top: '8px',
                                                left: '8px',
                                                right: '8px',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'flex-start'
                                            }}>
                                                {/* Left Side Badges */}
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                    {/* Order Type Badge */}
                                                    <div style={{
                                                        background: product.orderType === 'ALL' ? '#6f42c1' : 
                                                                product.orderType === 'PICKUP' ? '#fd7e14' : '#20c997',
                                                        color: 'white',
                                                        padding: '2px 8px',
                                                        borderRadius: '4px',
                                                        fontSize: '0.65rem',
                                                        fontWeight: '600'
                                                    }}>
                                                        {product?.orderType}
                                                    </div>

                                                    {/* New Badge */}
                                                    {product?.isNew && (
                                                        <div style={{
                                                            background: '#ff6b6b',
                                                            color: 'white',
                                                            padding: '2px 6px',
                                                            borderRadius: '4px',
                                                            fontSize: '0.6rem',
                                                            fontWeight: '600'
                                                        }}>
                                                            NEW
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Right Side Badges */}
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-end' }}>
                                                    {/* Status Badge */}
                                                    <div style={{
                                                        background: product.status === 'ACTIVE' ? '#28a745' : '#6c757d',
                                                        color: 'white',
                                                        padding: '2px 8px',
                                                        borderRadius: '4px',
                                                        fontSize: '0.65rem',
                                                        fontWeight: '600'
                                                    }}>
                                                        {product.status}
                                                    </div>

                                                    {/* Food Type Dot */}
                                                    <div style={{
                                                        width: '16px',
                                                        height: '16px',
                                                        borderRadius: '50%',
                                                        background: product.foodType === 'VEG' ? '#28a745' : 
                                                                product.foodType === 'NON-VEG' ? '#dc3545' : '#17a2b8',
                                                        border: '2px solid white',
                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                                                    }} />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Content Section */}
                                        <Card.Body style={{ 
                                            padding: '0.75rem',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            height: 'calc(100% - 140px)'
                                        }}>
                                            {/* Product Title */}
                                            <div style={{ 
                                                fontSize: '0.8rem', 
                                                fontWeight: '600', 
                                                color: '#333',
                                                marginBottom: '0.4rem',
                                                lineHeight: '1.3',
                                                display: '-webkit-box',
                                                WebkitLineClamp: '2',
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                height: '2.2rem'
                                            }}>
                                                {product.name}
                                            </div>

                                            {/* Category */}
                                            <div style={{ 
                                                fontSize: '0.7rem',
                                                color: '#6c757d',
                                                marginBottom: '0.5rem'
                                            }}>
                                                {product.classType}
                                            </div>
                                            
                                            {/* Pricing Section */}
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'center',
                                                marginBottom: '0.75rem'
                                            }}>
                                                <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                                                    <span style={{ 
                                                        fontSize: '0.9rem', 
                                                        fontWeight: '700', 
                                                        color: '#28a745'
                                                    }}>
                                                        {formatPrice(product.offerPrice)}
                                                    </span>
                                                    <span style={{ 
                                                        color: '#6c757d', 
                                                        textDecoration: 'line-through',
                                                        fontSize: '0.7rem'
                                                    }}>
                                                        {formatPrice(product.mrp)}
                                                    </span>
                                                </div>
                                                
                                                {/* Food Type Text */}
                                                <span style={{ 
                                                    fontSize: '0.65rem',
                                                    color: '#6c757d',
                                                    fontWeight: '500'
                                                }}>
                                                    {product.foodType}
                                                </span>
                                            </div>
                                            
                                            {/* Action Button */}
                                            <Button 
                                                variant="outline-danger" 
                                                size="sm"
                                                style={{ 
                                                    fontSize: '0.7rem',
                                                    padding: '0.3rem 0.6rem',
                                                    fontWeight: '500',
                                                    border: '1px solid #dc3545',
                                                    color: '#dc3545',
                                                    borderRadius: '4px',
                                                    transition: 'all 0.2s ease',
                                                    marginTop: 'auto'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.background = '#dc3545';
                                                    e.target.style.color = 'white';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.background = 'transparent';
                                                    e.target.style.color = '#dc3545';
                                                }}
                                                onClick={() => handleRemoveProduct(product._id)}
                                            >
                                                Remove
                                            </Button>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    ) : (
                        <div style={{ textAlign: 'center', padding: '3rem 0' }}>
                            <div 
                                style={{ 
                                    fontSize: '4rem', 
                                    color: '#6c757d', 
                                    marginBottom: '1rem' 
                                }}
                                className="bi bi-inboxes"
                            ></div>
                            <h5 style={{ marginTop: '1rem' }}>No promoted products found</h5>
                            <p style={{ color: '#6c757d' }}>There are currently no products being promoted.</p>
                            {/* <Button variant="primary" style={{ marginTop: '0.5rem' }} onClick={handleOpenAddModal}>
                                Add Promotion
                            </Button> */}
                        </div>
                    )}

                    { openAddModal && (
                        <Modal show={openAddModal} onHide={handleCloseAddModal} size="lg" backdrop="static">
                            <Modal.Header closeButton>
                                <Modal.Title>Promote Products</Modal.Title>
                            </Modal.Header>
                            <Form 
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    if (promotedProducts?.length === 0) {
                                        handleSubmit(e);
                                    } else {
                                        handleEditSubmit(e);
                                    }
                                }}
                            >
                                <Modal.Body>
                                    <Form.Group className="mb-3">
                                        <Form.Label className='fw-semibold'>
                                            Select Products to Promote in Outlets <span className='text-danger'>*</span>
                                        </Form.Label>
                                        <Select
                                            value={selectedProducts}
                                            onChange={handleProductChange}
                                            options={filteredProducts}
                                            isLoading={loadingProducts}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            placeholder="Search and select products..."
                                        />
                                        <Form.Text className="text-muted">
                                            Select one or more products to promote
                                        </Form.Text>
                                    </Form.Group>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCloseAddModal}>
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="primary" 
                                        type="submit"
                                        disabled={isAddBtnLoading || selectedProducts?.length === 0}
                                    >
                                        {isAddBtnLoading ? 'Promoting...' : 'Promote Products'}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    ) }
                </div>
            </div>
        </React.Fragment>
    )
}

export default PromoteProducts;